import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';

export enum Situation {
  open = 'OPEN',
  settled = 'SETTLED',
}

export enum FilterByDate {
  emission = 'EMISSION',
  dueDate = 'DUE_DATE',
  receipt = 'RECEIPT',
}

export interface ByFinancialFormValues extends ReportDateInterface {
  employees: string;
  documents: string;
  situation: Situation;
  filterByDate: FilterByDate;
}
